module.exports = require('./upper-case');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/string/uc.js
// module id = 315
// module chunks = 0 1 2